import React from 'react';
import {connect} from 'react-redux';
import {DescriptiveText, Page, Tile, Row, Button} from '../../shared';
import Table from '../../shared/components/Table';
import debug from 'debug';
import PropTypes from 'prop-types';
import {gatherData, goHome} from '../../shared/utils/utils';
import {_openModal} from '../../shared/reducers/modals';
import {_clearAgent, _createSession, _gatherEntitlements, _switchSession} from '../../shared/reducers/user';
import {_clearDefaultContainerID} from '../reducers/defaultContainerID';

const log = debug('circleblack:advisor:SsoSelectUser');

const gatherTokenUsers = gatherData('/auth/sso/users/token');
const gatherSessionUsers = gatherData('/auth/sso/users/session');

const SsoSelectUser = props => {
  const {clearAgent, clearDefaultContainerID, createSession, gatherEntitlements, switchSession, openModal, session} = props;
  const {agent, profile, ssoToken} = session;
  const [data, setData] = React.useState([]);

  const selectUser = user => {
    const source = agent?.id ? agent : profile;
    if (source.role && source.id === user.id) {
      if (agent?.id) {
        clearAgent();
        clearDefaultContainerID();
      }
      goHome(source.role);
    } else {
      if (ssoToken) {
        return createSession({email: user.email})
          .then(created => !!created && gatherEntitlements());
      }
      return switchSession({email: user.email});
    }
  };

  React.useEffect(() => {
    if (ssoToken) {
      gatherTokenUsers({ssoToken})
        .then(res => setData(res));
    } else {
      gatherSessionUsers(null, {runAsSelf: true})
        .then(res => setData(res));
    }
  }, []);

  log('rendering', props);

  return <Page>
    <Tile key='ssoSelectUser' title='Single Sign-On'>
      <DescriptiveText>Select User</DescriptiveText>
      <Row justifySubRow={'right'}>
        <Button importance={'primary'}
                size={'md'}
                label={'Link Another User'}
                action={() => openModal({type: 'LinkUserModal'})}/>
      </Row>
      <Table dataSet={data}
             columns={[
               {title: 'User', dataPoint: 'name', type: 'text', minWidth: 120, isSortable: true},
               {title: 'Role', dataPoint: 'roleDisplayName', type: 'text', minWidth: 120, isSortable: true},
               {title: 'Email', dataPoint: 'email', type: 'text', minWidth: 120, isSortable: true},
             ]}
             defaultSort={{
               column: 'name',
               desc: false,
             }}
             rowOnClick={selectUser}
             maxHeight={'calc(100vh - 200px)'}>
      </Table>
    </Tile>
  </Page>;
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  clearAgent: () => dispatch(_clearAgent()),
  clearDefaultContainerID: () => dispatch(_clearDefaultContainerID()),
  createSession: credentials => dispatch(_createSession(credentials)),
  gatherEntitlements: () => dispatch(_gatherEntitlements()),
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
  switchSession: credentials => dispatch(_switchSession(credentials)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SsoSelectUser);

SsoSelectUser.propTypes = {
  clearAgent: PropTypes.func.isRequired,
  clearDefaultContainerID: PropTypes.func.isRequired,
  createSession: PropTypes.func.isRequired,
  gatherEntitlements: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  session: PropTypes.shape({
    ssoToken: PropTypes.string,
    profile: PropTypes.shape({
      id: PropTypes.number.isRequired,
      role: PropTypes.string.isRequired,
    }),
    agent: PropTypes.shape({
      id: PropTypes.number.isRequired,
      role: PropTypes.string.isRequired,
    }),
  }).isRequired,
  switchSession: PropTypes.func.isRequired,
};
